const PROFILE_CACHE_KEY = 'digidex.profile.cache';
const PROFILE_CACHE_TTL_MS = 9 * 60 * 1000;

export function getCachedProfile() {
  try {
    const cached = JSON.parse(sessionStorage.getItem(PROFILE_CACHE_KEY) || 'null');
    if (!cached || cached.expiresAt <= Date.now()) {
      sessionStorage.removeItem(PROFILE_CACHE_KEY);
      return null;
    }
    return cached.profile;
  } catch {
    return null;
  }
}

export function cacheProfile(profile) {
  try {
    sessionStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify({
      profile,
      expiresAt: Date.now() + PROFILE_CACHE_TTL_MS
    }));
  } catch {
    // Session storage can be unavailable in private/restricted browser modes.
  }
  window.dispatchEvent(new CustomEvent('profile:changed', { detail: profile }));
  return profile;
}

export function clearCachedProfile() {
  try { sessionStorage.removeItem(PROFILE_CACHE_KEY); } catch { /* no-op */ }
  window.dispatchEvent(new CustomEvent('profile:changed', { detail: null }));
}
